import type { ITpcFlexAnswerData } from '@common/validation/customControls/tpcFlex/tpcFlexAnswerSchema';

export const initialData: ITpcFlexAnswerData = {
    answer: null,
};
